// extracted by mini-css-extract-plugin
export var article = "heroArticle-module--article--UtXJl";
export var extroardinaire = "heroArticle-module--extroardinaire--UsFLn";
export var visuallyHiddenHeader = "heroArticle-module--visuallyHiddenHeader--PQdvH";
export var wrapper = "heroArticle-module--wrapper--uOzNT";